const lang = {
    en: {
        TABLE_OF_CONTENTS: `Table of Contents`,
    },
    de: {
        TABLE_OF_CONTENTS: `Inhaltsverzeichnis`,
    },
    lt: {
        TABLE_OF_CONTENTS: `Turinys`,
    },
}

module.exports = lang